import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import { TabContext, TabPanel } from '@mui/lab';

import {
  adminGetSubTopicById,
  getSubTopicState,
} from '../../../store/SubTopicSlice';
import { resetQuestion, resetQuestionList } from '../../../store/QuestionSlice';
import { useAppSelector } from '../../../hooks';
import PageHeader from './components/PageHeader';
import TabBar, { ITabItem } from '../../../components/Tab/TabBar';
import ManageQuestions from './ManageQuestions';
import LessonMaterials from './LessonMaterials';

const tabs: ITabItem[] = [
  {
    index: 0,
    key: 'lessonMaterials',
    title: 'Lesson Materials',
  },
  {
    index: 1,
    key: 'questions',
    title: 'Questions',
  },
];

const ManageQuestionsHome: React.FC = () => {
  const urlParams = useParams();
  const location = useLocation();
  const dispatch = useDispatch();

  // Store
  const subTopicState = useAppSelector(getSubTopicState);

  const questyStringParams = new URLSearchParams(location.search);
  const urlQuestionId = questyStringParams.get('questionId') || '';

  // State
  const [selectedTab, setSelectedTab] = useState<ITabItem>(
    tabs[urlQuestionId ? 1 : 0]
  );

  const subTopicData = subTopicState.subTopic;
  const topicData =
    subTopicData && subTopicData.topic ? subTopicData.topic : undefined;

  let curriculumName = '';
  let subjectName = '';
  let gradeName = '';
  let subjectCodeName = '';
  let topicName = '';
  let subTopicName = '';

  if (subTopicData && topicData) {
    const { curriculum, subject, grade, subjectCode, name } = topicData;

    curriculumName = curriculum;
    subjectName = subject;
    gradeName = grade;
    subjectCodeName = subjectCode;
    topicName = name;
    subTopicName = subTopicData.name;
  }

  useEffect(() => {
    dispatch(resetQuestionList());
    dispatch(resetQuestion());

    if (urlParams.subTopicId) {
      dispatch(
        adminGetSubTopicById({
          id: urlParams.subTopicId,
        })
      );
    }
  }, []);

  const onTabChange = (event: React.SyntheticEvent, value: number) => {
    setSelectedTab(tabs[value]);
  };

  const renderTabPanel = () => {
    if (selectedTab.index === 0) {
      return (
        <TabPanel
          value={selectedTab.index.toString()}
          style={{ padding: '24px 0' }}
        >
          <LessonMaterials />
        </TabPanel>
      );
    }

    if (selectedTab.index === 1) {
      return (
        <TabPanel
          value={selectedTab.index.toString()}
          style={{ padding: '24px 0' }}
        >
          <ManageQuestions />
        </TabPanel>
      );
    }

    return null;
  };

  return (
    <div>
      {subTopicData ? (
        <PageHeader
          curriculum={curriculumName}
          subject={subjectName}
          grade={gradeName}
          subjectCode={subjectCodeName}
          topic={topicName}
          subTopic={subTopicName}
        />
      ) : null}
      <TabContext value={selectedTab.index.toString()}>
        <div style={{ padding: '30px' }}>
          <Box>
            <TabBar
              selectedTab={selectedTab}
              tabs={tabs}
              onChange={onTabChange}
            />
          </Box>
          {renderTabPanel()}
        </div>
      </TabContext>
    </div>
  );
};

export default ManageQuestionsHome;
